<template>
  <div class="order-items">
    <app-line
      v-for="line in lines"
      :key="line.id"
      :line="line"></app-line>
  </div>
</template>

<script>
import Line from './Line.vue'

export default {
  props: ['lines'],
  components: {
    appLine: Line
  }
}
</script>

<style>
  .order-items {
    width: 95%;
    max-width: 400px;
    margin: auto;
  }

  /* @media screen and (max-width: 320px) {
    .order-items {
      max-height: 175px;
      margin: 3px;
    }
  } */
</style>



// WEBPACK FOOTER //
// src/components/lines/Lines.vue